export const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight }
}

export const isPhone = () => {
    return /Mobi|iPhone|Android(?!.*Tablet)/i.test(navigator.userAgent) && window.innerWidth < 768;
}